
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'ホーム' },
    { path: '/about', label: '会社概要' },
    { path: '/services', label: 'サービス' },
    { path: '/faq', label: 'よくある質問' },
    { path: '/contact', label: 'お問い合わせ' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/fbe82816bfa2944cd2cddb1856f203c2.png"
              alt="飛翠ロゴ"
              className="h-12 w-auto"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-[#A7D676]'
                    : isScrolled
                    ? 'text-gray-700 hover:text-[#A7D676]'
                    : 'text-gray-800 hover:text-[#A7D676]'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <Link
            to="/contact"
            className="hidden lg:block bg-[#A7D676] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#96c565] transition-colors whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
          </Link>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-gray-800'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-[#A7D676]'
                    : 'text-gray-700 hover:text-[#A7D676]'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
